// src/hooks/useSocket.js
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useStore } from '../store/useStore';
import toast from 'react-hot-toast';

let socket = null;

export function useSocket() {
  const initialized = useRef(false);
  const { addLogs, updateAlert, addAlert, setAgentStatus, setAgentFindings, setSources } = useStore();

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    socket = io('/', {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
    });

    socket.on('connect', () => {
      console.log('[socket] connected:', socket.id);
      socket.emit('subscribe-logs', { sources: [], levels: [] });
    });

    socket.on('new-logs', ({ logs }) => {
      addLogs(logs);
    });

    socket.on('alert-updated', (alert) => updateAlert(alert));

    // Merge a single updated source into the sources list
    socket.on('source-status', (updatedSource) => {
      const current = useStore.getState().sources;
      const exists  = current.some(s => s.type === updatedSource.type);
      setSources(
        exists
          ? current.map(s => s.type === updatedSource.type ? updatedSource : s)
          : [...current, updatedSource]
      );
    });

    socket.on('new-alert', (alert) => {
      addAlert(alert);
      if (alert.severity === 'CRITICAL') {
        toast.error(`🚨 ${alert.title}`, { duration: 8000 });
      }
    });

    socket.on('agent-status', ({ status, tool }) => {
      setAgentStatus(status, tool);
    });

    socket.on('agent-result', (result) => {
      setAgentFindings(result);
      toast.success('AI investigation complete');
    });

    socket.on('disconnect', () => console.log('[socket] disconnected'));

    return () => {
      socket?.disconnect();
      initialized.current = false;
    };
  }, []);

  return socket;
}

export function getSocket() { return socket; }
